import clsx from 'clsx';

/**
 * If we want to replace in the future clasx for classname, etc just replace here.
 */

const classnames = clsx;

export default classnames;
